




import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({})
export default class ProgressBar extends Vue {
  @Prop({ type: Number, required: true })
  private completionPercentage!: number;
}
